export default __webpack_public_path__ + "static/media/menu-2.ea662197.jpg";